(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .service('RequiredDocumentCustomService',RequiredDocumentCustomService);

    RequiredDocumentCustomService.$inject = ['$http'];

    function RequiredDocumentCustomService($http) {
        return {
            getRequiredDocumentsByShipmentDocumentId: getRequiredDocumentsByShipmentDocumentId,
            getRequiredDocumentByShipmentDocumentIdAndType: getRequiredDocumentByShipmentDocumentIdAndType,
            getFullRequiredDocumentByShipmentDocumentIdAndType: getFullRequiredDocumentByShipmentDocumentIdAndType,
            getRequiredDocumentsByShipmentId: getRequiredDocumentsByShipmentId,
            updateRequiredDocumentReceivedDate: updateRequiredDocumentReceivedDate,
            resetReceivedAndApprovedDates: resetReceivedAndApproveDates,
            resetApprovedDate: resetApprovedDate,
            resetReceivedDate: resetReceivedDate
        }

        function getRequiredDocumentsByShipmentDocumentId(id) {
            var url = "api/required-documents/shipment-document/" + id;
            return $http.get(url);
        }

        function getRequiredDocumentByShipmentDocumentIdAndType(id, type) {
            var url = "api/required-documents/shipment-document/" + id + "/type/" + type;
            return $http.get(url);
        }

        function getFullRequiredDocumentByShipmentDocumentIdAndType(id, type) {
            var url = "api/required-documents/shipment-document/" + id + "/type/" + type + "/full";
            return $http.get(url);
        }

        function getRequiredDocumentsByShipmentId(id) {
            var url = "api/required-documents/shipment/" + id;
            return $http.get(url);
        }

        function updateRequiredDocumentReceivedDate(id, date) {
            var url = "api/required-documents/received/" + id + "?receivedDate=" + date;
            return $http.post(url);
        }

        function resetReceivedAndApproveDates(id) {
            var url = "api/required-documents/" + id + "/received/approved/reset";
            return $http.post(url);
        }

        function resetApprovedDate(id) {
            var url = "api/required-documents/" + id + "/approved/reset";
            return $http.post(url);
        }

        function resetReceivedDate(id) {
            var url = "api/required-documents/" + id + "/received/reset";
            return $http.post(url);
        }
    }
})();
